module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "Phase",
    class: {
      'Phase--optional': _vm.itemValues.optional, 'Phase--noTime': !_vm.itemValues.time
    }
  }, [_c('span', {
    staticClass: "Phase-Name"
  }, [_vm._v(_vm._s(_vm.itemValues.name))]), _vm._v(" "), _c('span', {
    staticClass: "Phase-Price"
  }, [_c('span', [_vm._v(_vm._s(_vm.itemValues['Price-Long']))]), _vm._v(" "), (_vm.itemValues.taxes !== undefined) ? _c('div', [_vm._v("zzgl. " + _vm._s(_vm.itemValues.taxes) + "% Ust.")]) : (_vm.itemValues['Taxes-19']) ? _c('div', [_vm._v("zzgl. 19% USt.")]) : _c('div', [_vm._v("zzgl. 7% USt.")])]), _vm._v(" "), (!!_vm.itemValues['time']) ? _c('span', {
    staticClass: "Phase-Time"
  }, [_vm._v(_vm._s(_vm.itemValues['Time-Long']))]) : _vm._e(), _vm._v(" "), _c('ul', [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-207cbf6f","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/page/Phase.vue
// module id = 160
// module chunks = 4